import { Box, Image, UnorderedList, ListItem, Text, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import LandingPageActionComponent from '../../common/LandingPageAction';

const LearningTab = ({ text, image, points, action }: any) => {
	return (
		<Box display="flex" flexDir={{ base: 'column', md: 'row' }} justifyContent="space-between" gap={{ base: '20px', md: '30px' }}>
			<Box maxW={{ md: '45%' }} pt={{ md: '25px' }}>
				<Text as="h3" mb="4" textStyle="h3" display={{ base: 'none', md: 'block' }}>
					{text}
				</Text>
				<Box mb={'3'}>
					{points &&
						points?.length > 0 &&
						(points.length === 1 ? (
							points[0]
						) : (
							<UnorderedList>
								{points.map((point: any, index: number) => (
									<ListItem key={index} color="#21191B">
										<Text textStyle="subtitle2">{point}</Text>
									</ListItem>
								))}
							</UnorderedList>
						))}
				</Box>
				<Box>{action ? <LandingPageActionComponent {...action} /> : null}</Box>
			</Box>

			<Box display={{ base: 'none', md: 'block' }} maxH="267px">
				<Image rounded={'24px'} h={'auto'} maxH="267px" w="fit" m="auto" src={image} alt="" />
			</Box>
		</Box>
	);
};

export default LearningTab;
